// extracted by mini-css-extract-plugin
module.exports = {"zombie-purge-success-ribbon":"ZombiePurgeSucess_zombie-purge-success-ribbon__PC6gv"};